import React, { useCallback, useEffect, useRef, useState } from "react";
import * as RB from "react-bootstrap";
import { Link } from "react-router-dom";
import ReasonModal from "../../ReasonModal";
import { useSelector } from "react-redux";
import * as utils from "../../../Utils/comman";
import logo from "./../../../assets/images/logo.png";
import "./pdf.css";
import { formatAmount } from "../../../Utils/comman";

import moment from "moment";
import { useLoader } from "../../../Loader";

function Pdf({ pdfContainerRef, rowData }) {
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);
  const { startLoader, stopLoader } = useLoader();

  const currentDateTime = moment().format("DD/MM/YYYY, h:mm A");
  const GstNo = process.env.REACT_APP_VURA_GSTIN_NO;
  const PanNo = process.env.REACT_APP_VURA_PAN_NO;

  const calculateTotals = () => {
    let totalNetAmount = 0;
    let totalCGST = 0;
    let totalSGST = 0;
    let totalIGST = 0;
    const packing_charge = Number(rowData?.packing_charge);
    const transport_charge = Number(rowData?.transport_charge);
    const other_charge = Number(rowData?.other_charge);

    rowData?.po_items?.forEach((item) => {
      const itemTotal = Number(item.qty) * Number(item.price);
      const cgstAmount = (itemTotal * Number(item.cgst_per)) / 100;
      const sgstAmount = (itemTotal * Number(item.sgst_per)) / 100;
      const igstAmount = (itemTotal * Number(item.igst_per)) / 100;

      totalNetAmount += itemTotal;
      totalCGST += cgstAmount;
      totalSGST += sgstAmount;
      totalIGST += igstAmount;
    });

    return {
      totalNetAmount,
      totalCGST,
      totalSGST,
      totalIGST,
      grandTotal:
        totalNetAmount +
        totalCGST +
        totalSGST +
        totalIGST +
        packing_charge +
        transport_charge +
        other_charge,
    };
  };

  const totals = calculateTotals();

  const convertToWords = (num) => {
    const units = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const scales = ["", "Thousand", "Lakh", "Crore"];

    const convertBelowThousand = (n) => {
      let str = "";
      if (n > 99) {
        str += units[Math.floor(n / 100)] + " Hundred ";
        n %= 100;
      }
      if (n > 19) {
        str += tens[Math.floor(n / 10)] + " ";
        n %= 10;
      }
      if (n > 0) {
        str += units[n] + " ";
      }
      return str.trim();
    };

    const convertIndianNumbering = (n) => {
      const parts = [];
      const crore = Math.floor(n / 10000000);
      if (crore > 0) {
        parts.push(convertBelowThousand(crore) + " Crore");
        n %= 10000000;
      }
      const lakh = Math.floor(n / 100000);
      if (lakh > 0) {
        parts.push(convertBelowThousand(lakh) + " Lakh");
        n %= 100000;
      }
      const thousand = Math.floor(n / 1000);
      if (thousand > 0) {
        parts.push(convertBelowThousand(thousand) + " Thousand");
        n %= 1000;
      }
      if (n > 0) {
        parts.push(convertBelowThousand(n));
      }
      return parts.join(" ");
    };

    // Split the number into the main part and the decimal part
    const mainPart = Math.floor(num);
    const decimalPart = Math.round((num - mainPart) * 100);

    // Convert the main part to words
    let words = convertIndianNumbering(mainPart);
    if (words) {
      words += " Rupees";
    }

    // Convert the decimal part to words if it exists
    if (decimalPart > 0) {
      words += " and " + convertBelowThousand(decimalPart) + " Paise";
    }

    return words || "Zero Rupees";
  };

  const venderDetail = rowData?.vendor_details[0];

  useEffect(() => {
    if (rowData) {
      console.log(rowData);
      fetchStates();
      fetchDistricts(rowData?.billing_state);
      fetchCities(rowData?.billing_district);
    }
  }, [rowData]);
  const fetchStates = () => {
    startLoader();
    utils
      .callAPI("get", `/state/list`)
      .then((res) => {
        setStates(res || []);
        stopLoader();
      })
      .catch(() => {
        setStates([]);
        stopLoader();
      });
  };

  const fetchDistricts = (stateId) => {
    startLoader();
    utils
      .callAPI("get", `/district/list?stateId=${stateId}`) // API to fetch districts
      .then((res) => {
        const data = Array.isArray(res) ? res : [];
        setDistricts(data);
        stopLoader();
      })
      .catch(() => {
        setDistricts([]);
        stopLoader();
      });
  };

  const fetchCities = (districtId) => {
    startLoader();
    utils
      .callAPI("get", `/city/by-district-list?districtId=${districtId}`) // API to fetch cities by district
      .then((res) => {
        const data = Array.isArray(res) ? res : [];
        setCities(data);
        stopLoader();
      })
      .catch(() => {
        setCities([]);
        stopLoader();
      });
  };

  const getStateName = (id) =>
    states?.find((item) => item.state_code === id)?.state_name || "";
  const getDistrictName = (id) =>
    districts?.find((item) => item.district_code === id)?.district_name || "";
  const getCityName = (id) =>
    cities?.find((item) => item.city_code === id)?.city_name || "";

  return (
    <>
      <div className="po-pdf-container" ref={pdfContainerRef}>
        <div className="pb-2">{currentDateTime}</div>

        <tr className="">
          <td className="col-sm-10 text-center fw-bold fs-5 border-top border-start border-dark">
            VURA BAU-CHEMIE LLP.
          </td>
          <td className="col-sm-2 justify-content-center border-top border-start border-end border-dark align-center">
            <img src={logo} className="img-fluid px-5 py-2" alt="Logo" />
          </td>
        </tr>

        <table
          className="border table-responsive border-dark"
          style={{ borderColor: "black" }}
        >
          <tr className="border-top border-dark">
            <td className="text-center">
              REG. OFF. : 1302, 13TH FLOOR, ELITE BUSINESS HUB,NEAR PRAJAPATI
              BHAVAN, SOLA,AHMEDABAD-380060.GUJARAT
            </td>
          </tr>

          <tr class="border-top border-dark ">
            <td style={{ fontWeight: "bold" }} className="text-center col-sm-2">
              PURCHASE ORDER
            </td>
          </tr>

          <table class="po-header">
            <tr className="">
              <td style={{ borderRight: "1px solid black" }} className="w-50">
                <span
                  style={{ textDecoration: "underline" }}
                  className="fw-bold"
                >
                  Supplier
                </span>
                <br />
                <span className="fw-bold">{rowData?.companyName}</span>
                <br />
                <span className="fw-bold">
                  {`${venderDetail?.address} (${venderDetail?.addressType})`}
                </span>
                <br />
                <span className="fw-bold">
                  {`${venderDetail?.city_name},${venderDetail?.state_name},${venderDetail?.pincode}`}
                </span>
                <br />
                <span className="fw-bold">GSTIN: {venderDetail?.gstNo}</span>
                <br />
                <span className="fw-bold">
                  Contact Person:{" "}
                  {rowData?.vendor_name ? rowData?.vendor_name : "-"}
                </span>
                <br />
                <span className="fw-bold">
                  Contact No: {venderDetail?.mobileNo}
                </span>
                <br />
              </td>

              <td className="w-50 ">
                <table className="po-header-sec ">
                  <tr>
                    <td className="col-sm-4 fw-bold">Billing To:</td>

                    <td className="col-sm-8 fw-bold table-border-bottom">
                      {rowData?.billing_address ||
                      rowData?.billing_city ||
                      rowData?.billing_district ||
                      rowData?.billing_state ||
                      rowData?.billing_pincode
                        ? [
                            rowData.billing_address,
                            getCityName(rowData.billing_city),
                            getDistrictName(rowData.billing_district),
                            getStateName(rowData.billing_state),
                            rowData?.billing_pincode,
                          ]
                            .filter(Boolean)
                            .join(", ")
                        : "-"}
                    </td>
                  </tr>

                  <tr>
                    <td className="col-sm-4 fw-bold">GSTIN:</td>
                    <td className="col-sm-8 fw-bold">{GstNo}</td>
                  </tr>
                  <tr>
                    <td className="col-sm-4 fw-bold">PAN NO.</td>
                    <td className="col-sm-8 fw-bold">{PanNo}</td>
                  </tr>
                  {/* <tr>
                    <td className="col-sm-4 fw-bold">Delivery:</td>
                    <td className="col-sm-8 fw-bold">Factory</td>
                  </tr> */}
                  <tr>
                    <td className="col-sm-4 fw-bold">Delivery Date:</td>
                    <td className="col-sm-8 fw-bold">
                      {rowData?.delivery_date ? rowData?.delivery_date : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td className="col-sm-4 fw-bold">Terms of Payment:</td>
                    <td className="col-sm-8 fw-bold table-border-bottom">
                      {rowData?.terms_of_payment
                        ? rowData?.terms_of_payment
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td className="col-sm-4 fw-bold">Shipping To:</td>
                    <td className="col-sm-8 fw-bold table-border-bottom">
                      {rowData?.location_name ||
                      rowData?.address ||
                      rowData?.city ||
                      rowData?.district ||
                      rowData?.state ||
                      rowData?.pincode
                        ? [
                            rowData.location_name,
                            rowData.address,
                            rowData.city,
                            rowData.district,
                            rowData.state,
                            rowData?.pincode,
                          ]
                            .filter(Boolean)
                            .join(", ")
                        : "-"}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <table class="po-sec-header mb-0">
            <tr>
              {/* <td class="table-border-bottom fixed-width-quotation fw-bold">
                Quotation No.
              </td>
              <td class="table-border-left-bottom fixed-width-email">Email.</td> */}
              <td class="table-border-left-bottom fixed-width-order fw-bold">
                Purchase Order No.
              </td>
              <td class="table-border-left-bottom fixed-width-order-no">
                {rowData?.order_id ? rowData?.order_id : "-"}
              </td>
              <td class="table-border-left-bottom fixed-width-po-date fw-bold">
                Purchase Order Date
              </td>
              <td class="table-border-left-bottom fixed-width-po-date-value">
                {rowData?.order_date
                  ? moment(rowData?.order_date).format("DD/MM/YYYY")
                  : "-"}
              </td>
            </tr>
          </table>

          <table className="payslip-table">
            <thead>
              <tr>
                <th>Sr.</th>
                <th className="table-border-left text-center" colSpan={2}>
                  Description of Goods
                </th>
                <th className="table-border-left text-center">HSN</th>
                <th
                  className="table-border-left text-center text-wrap"
                  style={{ width: "70px", whiteSpace: "normal" }}
                >
                  No. Of Packages
                </th>

                <th className="table-border-left text-center">Qty</th>
                <th className="table-border-left text-center">UOM</th>
                <th className="table-border-left text-center">Rate Per</th>
                <th className="table-border-left text-center" colSpan={2}>
                  CGST
                </th>
                <th colSpan={2} className="table-border-left text-center">
                  SGST
                </th>
                <th colSpan={2} className="table-border-left text-center">
                  IGST
                </th>
                <th className="table-border-left text-center">Net Amount</th>
              </tr>
              <tr>
                <th></th>
                <th></th>
                <th colSpan={2}></th>
                <th></th>
                <th></th>
                <th></th>
                <th className="table-border-left text-center">%</th>
                <th className="table-border-left text-center">Amt</th>
                <th className="table-border-left text-center">%</th>
                <th className="table-border-left text-center">Amt</th>
                <th className="table-border-left text-center">%</th>
                <th className="table-border-left text-center">Amt</th>
                <th className="table-border-left text-center"></th>
              </tr>
            </thead>

            <tbody>
              {rowData?.po_items?.map((item, index) => {
                const itemTotal = Number(item.qty) * Number(item.price);
                const cgstAmount = (itemTotal * Number(item.cgst_per)) / 100;
                const sgstAmount = (itemTotal * Number(item.sgst_per)) / 100;
                const igstAmount = (itemTotal * Number(item.igst_per)) / 100;

                return (
                  <tr key={index}>
                    <td className="text-center table-border-bottom">
                      {index + 1}
                    </td>
                    <td
                      className="text-center table-border-left-bottom"
                      colSpan={2}
                    >
                      {item.product_name}
                    </td>
                    <td className="text-center table-border-left-bottom">
                      {item.hsn_code}
                    </td>
                    <td className="text-center table-border-left-bottom">
                      {item.no_of_packages}
                    </td>
                    <td className="text-center table-border-left-bottom">
                      {item.qty}
                    </td>
                    <td className="text-center table-border-left-bottom">
                      {item.unit}
                    </td>
                    <td className="text-center table-border-left-bottom">
                      {formatAmount(Number(item.price))}
                    </td>
                    <td className="text-center table-border-left-bottom">
                      {item.cgst_per}
                    </td>
                    <td className="text-center table-border-left-bottom">
                      {formatAmount(Number(cgstAmount))}
                    </td>
                    <td className="text-center table-border-left-bottom">
                      {item.sgst_per}
                    </td>
                    <td className="text-center table-border-left-bottom">
                      {formatAmount(Number(sgstAmount))}
                    </td>
                    <td className="text-center table-border-left-bottom">
                      {item.igst_per}
                    </td>
                    <td className="text-center table-border-left-bottom">
                      {formatAmount(Number(igstAmount))}
                    </td>
                    <td className="text-center table-border-left-bottom">
                      {formatAmount(itemTotal)}
                    </td>
                  </tr>
                );
              })}
            </tbody>

            <tr>
              <td
                colSpan={14}
                className="text-end border-end border-dark fw-bold"
              >
                Amount
              </td>
              <td className="text-end">
                {formatAmount(totals.totalNetAmount)}
              </td>
            </tr>

            <tr>
              <td
                colSpan={14}
                className="text-end border-end border-dark fw-bold"
              >
                Packing & Forwarding
              </td>
              <td className="text-end ">
                {formatAmount(rowData?.packing_charge)}
              </td>
            </tr>

            <tr>
              <td
                colSpan={14}
                className="text-end border-end border-dark fw-bold"
              >
                Transportation
              </td>
              <td className="text-end ">
                {formatAmount(rowData?.transport_charge)}
              </td>
            </tr>

            <tr>
              <td
                colSpan={14}
                className="text-end border-end border-dark fw-bold"
              >
                Other
              </td>
              <td className="text-end ">
                {formatAmount(rowData?.other_charge)}
              </td>
            </tr>

            <tr>
              <td
                colSpan={14}
                className="text-end border-end border-dark fw-bold"
              >
                CGST
              </td>
              <td className="text-end ">{formatAmount(totals.totalCGST)}</td>
            </tr>

            <tr>
              <td
                colSpan={14}
                className="text-end border-end border-dark fw-bold"
              >
                SGST
              </td>
              <td className="text-end ">{formatAmount(totals.totalSGST)}</td>
            </tr>

            <tr>
              <td
                colSpan={14}
                className="text-end border-end border-dark fw-bold"
              >
                IGST
              </td>
              <td className="text-end ">{formatAmount(totals.totalIGST)}</td>
            </tr>

            <tr>
              <td
                colSpan={14}
                className="text-end border-end border-top border-bottom border-dark fw-bold"
              >
                Total Amount
              </td>
              <td className="text-end fw-bold border-top border-bottom border-dark">
                {formatAmount(totals.grandTotal)}
              </td>
            </tr>

            <tr>
              <td
                colSpan={15}
                className="text-end border-bottom border-dark fw-bold"
              >
                Total Amount In Words :{" "}
                {`${convertToWords(Number(totals.grandTotal))} only`}
              </td>
            </tr>

            <tr>
              <td
                colSpan={15}
                className="align-top fw-bold border-top border-bottom border-dark pt-1"
              >
                Remark
              </td>
            </tr>
          </table>

          <table style={{ width: "100%" }}>
            {/* Terms & Conditions Title */}
            <tr>
              <td
                colspan="2"
                style={{
                  textAlign: "left",
                  fontWeight: "bold",
                  paddingLeft: 5,
                }}
              >
                <span>Terms & Conditions</span>
              </td>
            </tr>

            {/* Condition 1 */}
            <tr>
              <td colspan="2">
                <span
                  style={{
                    display: "block",
                    fontSize: "12px",
                    paddingLeft: 5,
                    marginTop: 5,
                  }}
                >
                  1). Please mention place of supply as "Gujarat" and State Code
                  - 24 in the invoice to ensure that our eligibility of claiming
                  credit of GST amount is not adversely impacted.
                </span>
              </td>
            </tr>

            {/* Condition 2 */}
            <tr>
              <td colspan="2">
                <span
                  style={{
                    display: "block",
                    fontSize: "12px",
                    paddingLeft: 5,
                  }}
                >
                  2). If the supply is from within Gujarat kindly charge CGST &
                  SGST at the applicable rates and if the supply is from outside
                  Gujarat, kindly charge IGST at the applicable rate to ensure
                  that our eligibility of claiming credit of the said levies is
                  not adversely impacted.
                </span>
              </td>
            </tr>

            {/* Condition 3 */}
            <tr>
              <td colspan="2">
                <span
                  style={{
                    display: "block",
                    fontSize: "12px",
                    paddingLeft: 5,
                  }}
                >
                  3). Weighment at our site and analysis in our laboratory will
                  be considered final for the payment.
                </span>
              </td>
            </tr>

            {/* Condition 4 */}
            <tr>
              <td colspan="2">
                <span
                  style={{
                    display: "block",
                    fontSize: "12px",
                    paddingLeft: 5,
                  }}
                >
                  4). Delivery Challan and Invoices in duplicate should be
                  forwarded along with supply.
                </span>
              </td>
            </tr>

            {/* Condition 5 */}
            <tr>
              <td colspan="2">
                <span
                  style={{
                    display: "block",
                    fontSize: "12px",
                    paddingLeft: 5,
                  }}
                >
                  5). Rates mentioned in the order are firm and not subject to
                  any price variation or escalation.
                </span>
              </td>
            </tr>

            {/* Condition 6 */}
            <tr>
              <td colspan="2">
                <span
                  style={{
                    display: "block",
                    fontSize: "12px",
                    paddingLeft: 5,
                  }}
                >
                  6). All disputes involving litigation shall be Ahmedabad
                  Jurisdiction only.
                </span>
              </td>
            </tr>

            {/* Missing Details Section */}
            <tr>
              <td colspan="2">
                <span
                  style={{
                    display: "block",
                    fontSize: "12px",
                    paddingLeft: 5,
                  }}
                >
                  If any of the following details are missing in your Tax
                  Invoice, the material will not be Inwarded/Payment:
                </span>
              </td>
            </tr>

            {/* Detail 1 */}
            <tr>
              <td colspan="2">
                <span
                  style={{
                    display: "block",
                    fontSize: "12px",
                    paddingLeft: 5,
                  }}
                >
                  1). Required Original / Duplicate Tax Invoice duly authorised
                  and Signed containing.
                </span>
              </td>
            </tr>

            {/* Detail 2 */}
            <tr>
              <td colspan="2">
                <span
                  style={{
                    display: "block",
                    fontSize: "12px",
                    paddingLeft: 5,
                  }}
                >
                  2). Mention our Name & Full address of our works in your
                  Invoice copy.
                </span>
              </td>
            </tr>

            {/* Detail 3 */}
            <tr>
              <td colspan="2">
                <span
                  style={{
                    display: "block",
                    fontSize: "12px",
                    paddingLeft: 5,
                  }}
                >
                  3). Mention Tax Invoice and Original for Recipient in your
                  Invoice copy.
                </span>
              </td>
            </tr>

            {/* Detail 4 */}
            <tr>
              <td colspan="2">
                <span
                  style={{
                    display: "block",
                    fontSize: "12px",
                    paddingLeft: 5,
                  }}
                >
                  4). Mention HSN Code of all supply items in your Invoice copy.
                </span>
              </td>
            </tr>

            {/* Detail 5 */}
            <tr>
              <td colspan="2">
                <span
                  style={{
                    display: "block",
                    fontSize: "12px",
                    paddingLeft: 5,
                  }}
                >
                  5). Mention your Name and Full Address with GST Registration
                  Number in your Invoice copy.
                </span>
              </td>
            </tr>

            {/* Detail 6 */}
            <tr>
              <td colspan="2">
                <span
                  style={{
                    display: "block",
                    fontSize: "12px",
                    paddingLeft: 5,
                  }}
                >
                  6). Signature required even in Proforma Invoice also for
                  Advance payment.
                </span>
              </td>
            </tr>
          </table>
        </table>
      </div>
    </>
  );
}

export default Pdf;
